export const getHashParams = (hash: string) =>
  Object.fromEntries(new URLSearchParams(hash.replace(/^#/, "")).entries());

/**
 * Validate a `returnTo` redirect target. Only same-origin paths are accepted —
 * anything that could resolve to a different origin (`//evil.com`,
 * `https://evil.com`, `/\evil.com`) is rejected to prevent open-redirect
 * attacks after sign-in. Returns `null` when the input is unsafe or absent.
 */
export const getSafeReturnTo = (returnTo: string | string[] | undefined | null): string | null => {
  const value = Array.isArray(returnTo) ? returnTo[0] : returnTo;
  if (!value || !value.startsWith("/")) return null;
  if (value.startsWith("//") || value.startsWith("/\\")) return null;
  return value;
};

/**
 * Sign-in URL that returns the user to where they were heading — so a shared
 * deep link survives the round-trip. `MfaVerify`/`MfaEnrol` consume the
 * `returnTo` once sign-in completes. An unsafe or self-referential target
 * (which would loop) falls back to a plain sign-in.
 */
export const loginHref = (returnTo: string): string => {
  const safe = getSafeReturnTo(returnTo);
  if (!safe || safe === "/login" || safe.startsWith("/login?")) return "/login";
  return `/login?returnTo=${encodeURIComponent(safe)}`;
};

/** The path and query currently in the address bar. Client-only. */
export const currentPathWithQuery = (): string => `${window.location.pathname}${window.location.search}`;
